/* src/app/webhook-creator/webhook-creator/webhook-multiple-context/webhook-multiple-context.component.scss */
.context-form {
  width: 50%;
  padding: 20px;
  float: right;
}
.webhook-context-container {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.webhook-context-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}
.edit-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.edit-panel-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.edit-panel-container-left {
  width: 50%;
}
.edit-panel-container-right {
  width: 50%;
}
td.cell-normal {
  text-overflow: ellipsis;
  overflow: hidden;
  word-spacing: unset;
  width: 100%;
  white-space: nowrap;
}
::ng-deep .ant-table-cell {
  word-break: break-word;
}
.search-box {
  padding: 8px;
}
.search-box input {
  width: 188px;
  margin-bottom: 8px;
  display: block;
}
.search-box button {
  width: 90px;
}
.search-button {
  margin-right: 8px;
}
.edit-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.edit-panel-action {
  display: flex;
  flex-direction: row;
  width: 100%;
}
nz-divider::after,
nz-divider::before {
  border-color: var(--tem-deep) !important;
}
/*# sourceMappingURL=webhook-multiple-context.component.css.map */
